var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('a-table',{staticClass:"j-table-force-nowrap",attrs:{"rowKey":"id","columns":_vm.columns,"dataSource":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }